import { FieldStatus } from '../data-access/types/stats';

export const formatSectorData = (
  data: FieldStatus,
  type: 'area' | 'number',
  unit?: string,
) => {
  if (!data.nbr_plots && !data.total_area) {
    return [{ name: 'empty', value: 1 }];
  }

  return Object.entries(data[`field_status_${type}`]).map(([name, value]) => {
    return {
      name,
      value,
      unit,
    };
  });
};
